import AdFootOrderComplete from './AdFootOrderComplete.vue'

export default AdFootOrderComplete
